import { Sheet, SheetRef } from "react-modal-sheet"
import { useRef } from "react"
import { CloseButton } from "./close-button"

const snapPoints = [0, 0.7, 1]

type NewContentHeight = "default" | "content" | "full"

export default function BottomSheet({
  isOpen,
  onClose,
  children,
  isPopup,
  zIndex = 40,
  disableDrag = false,
  contentHeight,
}: {
  isOpen: boolean
  zIndex?: number | string
  onClose: () => void
  isPopup?: boolean
  disableDrag?: boolean
  children: React.ReactNode
  contentHeight?: NewContentHeight
}) {
  const ref = useRef<SheetRef>(null)

  return (
    <Sheet
      ref={ref}
      isOpen={isOpen}
      onClose={onClose}
      style={{ zIndex }}
      // detent={contentHeight}
      disableDrag={disableDrag}
      // initialSnap={0.7}
      // snapPoints={snapPoints}
      // {...(contentHeight ? {} : { initialSnap: 1, snapPoints })}
    >
      <Sheet.Backdrop onTap={onClose} />
      <Sheet.Container
        style={{
          boxShadow: "rgba(0, 0, 0, 0.1) 0px -2px 16px",
          borderTopLeftRadius: "24px",
          borderTopRightRadius: "24px",
          backgroundColor: "var(--bg-card)",
        }}
      >
        <Sheet.Header
          style={
            isPopup
              ? { position: "absolute", zIndex: 10 }
              : { background: "transparent" }
          }
        />
        <CloseButton
          style={isPopup ? { position: "absolute", zIndex: 10 } : {}}
          top="14px"
          right="15px"
          position="absolute"
          onClick={onClose}
          rounded="full"
          size="xs"
          variant="subtle"
        />
        <Sheet.Content>{children}</Sheet.Content>
      </Sheet.Container>
    </Sheet>
  )
}
